import { Box, SystemIcon, Typography } from '@wishket/design-system';
import { ReactNode } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

import { Link } from '@/shared/Components';

interface TutorialCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  href: string;
  dimmed?: boolean;
}

const TutorialCard = ({
  title,
  description,
  icon,
  href,
  dimmed = false,
}: TutorialCardProps) => {
  return (
    <Link
      className={twMerge(
        'flex h-[74px] w-full min-w-[216px] items-center gap-4 rounded-2xl border border-dashed border-w-orange-300 bg-w-white py-5 pl-5 pr-4',
        dimmed && 'pointer-events-none border-none opacity-50',
        'desktop:h-[92px] desktop:min-w-[248px]'
      )}
      href={href}
    >
      {icon}
      <Box className={twJoin('flex-1', 'desktop:flex-col')}>
        <Typography
          variant="body2"
          className="hidden text-w-gray-600 desktop:block"
        >
          {description}
        </Typography>
        <Typography variant="body1" className="font-bold text-w-gray-900">
          {title}
        </Typography>
      </Box>
      {!dimmed && (
        <SystemIcon name="medium_arrow_right" className="text-w-gray-600" />
      )}
    </Link>
  );
};

export default TutorialCard;
